import { makeStyles, tokens } from '@fluentui/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IEmptyFormViewerProps {
    isAdd: boolean;
}

const useStyles = makeStyles({
    tableContentClass: {
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        borderRadius: tokens.borderRadiusMedium,
    },
});

const EmptyFormViewer: React.FC<IEmptyFormViewerProps> = ({ isAdd }) => {
    const styles = useStyles();
    const { t } = useTranslation();

    const message = isAdd ? t('selectLineItemToCreateStatement') : t('noDataAvailable');

    return <div className={styles.tableContentClass}>{message}</div>;
};

export default EmptyFormViewer;
